// |Array| Converts an array like object to an array. Handy for `arguments` or dom selectors

function toArray ( obj ) {
    return Array.prototype.slice.call( obj );
}

export default toArray;